import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchProductDetailsAPI(id) {
    const response = await fetch(`${baseURL}/api/version3/product/${id}`);
    if(!response.ok) throw new error("Failed to retch home data");
    return response.json()
}